import { createMuiTheme, responsiveFontSizes } from '@material-ui/core'

let Theme = createMuiTheme({
  palette: {
    primary: {
      main: '#32499F',
      // light: '#F6F4F2',
      // dark: '#7968EE',
    },
    secondary: {
      main: '#32499F',
    },
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 320,
      md: 750,
      lg: 1025,
      xl: 1920,
    },
  },
  typography: {
    fontFamily: 'Open Sans',
  },
})
Theme = responsiveFontSizes(Theme)

export default Theme
